export default "skymp5-front/12e0b27083f1955aef8db04461b6c9be.webp";